import { useEffect } from 'react';
import analytics from '../../utils/analytics';
import { removeLoadingIconFromParent } from '../../utils/globalUtils';
import { removeInitialLoader } from '../utils/bootstrapUtils';

export const useAppBootstrap = () => {
  // Initialize analytics in production and remove legacy loading icon
  useEffect(() => {
    if (process.env.NODE_ENV === 'production') analytics.init();
    removeLoadingIconFromParent();
  }, []);

  // Remove initial CASA loader when React root renders
  useEffect(() => {
    const root = document.getElementById('root');
    if (!root) return;

    const observer = new MutationObserver(() => {
      if (root.hasChildNodes()) {
        removeInitialLoader();
        observer.disconnect();
      }
    });

    observer.observe(root, { childList: true });

    return () => {
      observer.disconnect();
    };
  }, []);
};
